export default __webpack_public_path__ + "static/media/SuperDM.4927b69d.jpeg";